import urlPrefixes from '../../../constants/urlPrefixes';
import formatSearchQueryFromUrl from '../../formatters/formatForURL';
/**
 * create query part if exist
 * expected output /q/${searchQuery}
 */
export default function (query?: string): string {
  return query ? `/${urlPrefixes.query}/${formatSearchQueryFromUrl(query)}` : '';
}
